import axios from 'axios';

const axiosInstance = axios.create({
  baseURL:
    process.env.NEXT_PUBLIC_SHORT_DUST_URI ||
    'https://api-shortdust.olx.com.br',
  headers: {
    post: {
      'Content-Type': 'application/json',
    },
  },
  withCredentials: false,
  timeout: 10000,
});

const API_GENERATE_TOKEN = 'v1/login-tokens';

const getLoginToken = async (route) => {
  return axiosInstance.post(`${API_GENERATE_TOKEN}`, { route }).then((res) => {
    return res.data;
  });
};

export default getLoginToken;
